import $ from 'jquery';
import cx from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';
import Reflux from 'reflux';
/*
  Full Screen Toggle Button

  Controls whether a video player is displayed in full screen mode or not.
*/
export default class FullScreenToggleButton extends Reflux.Component {
    constructor(props) {
        super(props)
        this.state = {}
        this.store = props.ControlsStore;
        this.ControlsActions = this.store.ControlsActions;
    }
    componentDidMount() {
        this.bindEvents();
    }
    componentDidUpdate(prevProps, prevState) {
        this.bindEvents();
    }

    bindEvents() {
        //let $this = $(ReactDOM.findDOMNode(this));
    }
    shouldComponentUpdate(nextProps, nextState) {
        return nextState.isFullscreen != this.state.isFullscreen;
    }
    render() {
        const ButtonProps = {
            className: cx({
                'fs-exit': this.state.isFullscreen,
                'fs': !this.state.isFullscreen
            }),
            onClick: (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.ControlsActions.toggleFullscreen();
            }
        }
        return (
          <div className="fullscreen">
            <button {...ButtonProps}></button>
          </div>
        )
    }
} // FullScreenToggleButton
FullScreenToggleButton.propTypes = {
    ControlsStore: React.PropTypes.object.isRequired,
    "onClick": React.PropTypes.func
}
FullScreenToggleButton.defaultProps = {
    "onClick": () => {}
}


// WEBPACK FOOTER //
// ./medscape_modules/video/player-controls/full-screen-toggle-button.jsx